import React, { Component } from 'react';

// Catalog must stay in sync with additionalServices.js (details section)
// so wizard selections flow directly into the correct preset toggles.
const ADDITIONAL_SERVICES = [
	{
		label: 'Airport Transfers',
		icon: 'las la-shuttle-van',
		description: 'Ground transportation and airport pick-up/drop-off coordination for attendees.'
	},
	{
		label: 'Audio Visual (A/V)',
		icon: 'las la-video',
		description: 'Professional sound, lighting, screens, and technical direction for sessions.'
	},
	{
		label: 'Décor & Design',
		icon: 'las la-palette',
		description: 'Creative décor, theming, floral, and environmental design services.'
	},
	{
		label: 'Entertainment',
		icon: 'las la-music',
		description: 'Live music, performers, DJs, and entertainment programming.'
	},
	{
		label: 'Event Photography',
		icon: 'las la-camera',
		description: 'Professional photo and video capture throughout the event.'
	},
	{
		label: 'Floral Services',
		icon: 'las la-seedling',
		description: 'Floral arrangements, centerpieces, and botanical design.'
	},
	{
		label: 'Guest Speakers',
		icon: 'las la-microphone',
		description: 'Keynote speakers, facilitators, and expert presenters.'
	},
	{
		label: 'Off-site Activities',
		icon: 'las la-hiking',
		description: 'Excursions, team outings, and off-property experiences.'
	},
	{
		label: 'Production Services',
		icon: 'las la-film',
		description: 'Full-scale event production including staging, rigging, and show management.'
	},
	{
		label: 'Security Services',
		icon: 'las la-user-shield',
		description: 'On-site security personnel and access control.'
	},
	{
		label: 'Shuttle Services',
		icon: 'las la-bus',
		description: 'Group shuttle transportation between hotels, venues, and activity sites.'
	},
	{
		label: 'Signage & Branding',
		icon: 'las la-sign',
		description: 'Custom signage, banners, branded materials, and wayfinding.'
	},
	{
		label: 'Spa Services',
		icon: 'las la-spa',
		description: 'On-site spa treatments, wellness activities, or spa buyouts.'
	},
	{
		label: 'Team Building',
		icon: 'las la-puzzle-piece',
		description: 'Facilitated team-building activities and group engagement programs.'
	},
	{
		label: 'VIP Services',
		icon: 'las la-star',
		description: 'Elevated concierge, private experiences, and VIP guest management.'
	},
	{
		label: 'WiFi/Internet Upgrades',
		icon: 'las la-wifi',
		description: 'Dedicated bandwidth, hardline internet, or upgraded connectivity for the event.'
	}
];

class AdditionalServicesStep extends Component {
	toggleService = (label) => {
		const { data, onChange } = this.props;
		const selectedServices = [...(data.additionalServices || [])];
		const idx = selectedServices.indexOf(label);
		if (idx >= 0) {
			selectedServices.splice(idx, 1);
		} else {
			selectedServices.push(label);
		}
		onChange('additionalServices', selectedServices);
	};

	render() {
		const { data } = this.props;
		const selectedServices = data.additionalServices || [];

		return (
			<div className="rfp-step-content">
				<h1 className="rfp-step-title">Additional Services</h1>

				<p className="rfp-additional-services-desc">
					Select any onsite services you would like additional information on.
				</p>

				<div className="rfp-services-grid">
					{ADDITIONAL_SERVICES.map((service) => {
						const isSelected = selectedServices.includes(service.label);
						return (
							<div
								key={service.label}
								className={`rfp-service-card ${isSelected ? 'selected' : ''}`}
								onClick={() => this.toggleService(service.label)}
							>
								<div className="rfp-service-image-placeholder">
									<i className={`${service.icon} rfp-service-icon`} />
								</div>
								<div className="rfp-service-card-body">
									<div className="rfp-service-title">{service.label}</div>
									<div className="rfp-service-desc">{service.description}</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

export default AdditionalServicesStep;
